import creator from "../creator";
import selector from "../selector";

function constantNull() {
  return null;
}

export default function (name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function () {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/insert.js
// module id = 496
// module chunks = 0